import React from 'react'
import Heading from '../../../core/components/typography/heading/Heading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './feedChunk.css'

const generateFeedCards = (entries, FeedChunkCard) => {
  return entries.map((e,index)=>{
    return (
      <div key={index} className='feed-chunk__container'>
        <div className='feed-chunk__card-column'>
          <div className='feed-chunk__card-container'>
            <FeedChunkCard e={e} />
          </div>
        </div>
      </div>
    )
  })
}


const FeedChunk = ({timeago, entries, FeedChunkCard, isPrivate, isFirst, showPrivacy}) => {
  const feedCards = generateFeedCards(entries, FeedChunkCard)
  return (
    <div className='feed-chunk'>
      <div className='feed-chunk__head'>
        <div className='feed-chunk__timeago'>
          <Heading size='md' color='midGray' fontWeight='medium'>{timeago}</Heading>
        </div>
        {
          isFirst && showPrivacy ?
            isPrivate ?
              <span className='feed-chunk__privacy'>
                <FontAwesomeIcon icon={['fa', 'lock']} /> Private
              </span>
              : <span className='feed-chunk__privacy'>
                <FontAwesomeIcon icon={['fa', 'globe']} /> Public
              </span>
            : null
        }
      </div>
      {feedCards}
    </div>
  )
}

export default FeedChunk



// WEBPACK FOOTER //
// ./src/domains/user/components/FeedChunk.js